'use client';
import { createStyles } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var useStyles = createStyles((theme, params)=>{
    const { breakpoints } = params, mainParams = _object_without_properties_loose(params, [
        "breakpoints"
    ]);
    return {
        root: _extends({}, theme.fn.typography(mainParams), theme.fn.responsive(breakpoints)((localParams)=>theme.fn.typography(_extends({}, mainParams, localParams), true)))
    };
});

export { useStyles as default };
//# sourceMappingURL=Typography.styles.js.map
